var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftDuotone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    d: "M4 11h16v6.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 22 16.88 22 15.2 22H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 19.72 4 18.88 4 17.2z",
    opacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "evenodd",
    d: "M8.5 2.75a1.75 1.75 0 1 0 0 3.5h2.492l-.659-2.196A1.83 1.83 0 0 0 8.58 2.75zm2.75 5v2.5H4a1.25 1.25 0 1 1 0-2.5zm-5.49-1.5a3.25 3.25 0 0 1 2.74-5h.08a3.33 3.33 0 0 1 3.19 2.373l.23.767.23-.767a3.33 3.33 0 0 1 3.19-2.373h.08a3.25 3.25 0 0 1 2.74 5H20a2.75 2.75 0 0 1 .75 5.397v5.585c0 .813 0 1.469-.043 2-.045.546-.14 1.026-.366 1.47a3.75 3.75 0 0 1-1.639 1.64c-.444.226-.924.32-1.47.365-.531.043-1.187.043-2 .043H8.768c-.813 0-1.469 0-2-.043-.546-.045-1.026-.14-1.47-.366a3.75 3.75 0 0 1-1.64-1.639c-.226-.444-.32-.924-.365-1.47-.043-.531-.043-1.187-.043-2v-5.585A2.751 2.751 0 0 1 4 6.25zm-1.01 5.5v5.45c0 .852 0 1.447.038 1.91.037.453.107.714.207.912.216.423.56.767.984.983.197.1.458.17.912.207.462.037 1.057.038 1.909.038h2.45v-9.5zm8 0v9.5h2.45c.852 0 1.447 0 1.91-.038.453-.038.714-.107.912-.207.423-.216.767-.56.983-.983.1-.198.17-.459.207-.913.037-.462.038-1.057.038-1.909v-5.45zm7.25-1.5a1.25 1.25 0 1 0 0-2.5h-7.25v2.5zm-4.5-4a1.75 1.75 0 1 0 0-3.5h-.08c-.809 0-1.521.53-1.753 1.304l-.659 2.196z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftDuotone);
export default __webpack_public_path__ + "static/media/gift-duotone.fde860675a392bb76cda36045702a795.svg";
export { ForwardRef as ReactComponent };